var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463 463",
    enableBackground: "new 0 0 463 463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.5,0C32.075,0,0,32.075,0,71.5S32.075,143,71.5,143S143,110.925,143,71.5S110.925,0,71.5,0z M71.5,128    C40.346,128,15,102.654,15,71.5S40.346,15,71.5,15S128,40.346,128,71.5S102.654,128,71.5,128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,160C32.075,160,0,192.075,0,231.5S32.075,303,71.5,303s71.5-32.075,71.5-71.5S110.925,160,71.5,160z M71.5,288    C40.346,288,15,262.654,15,231.5S40.346,175,71.5,175s56.5,25.346,56.5,56.5S102.654,288,71.5,288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5,320C32.075,320,0,352.075,0,391.5S32.075,463,71.5,463s71.5-32.075,71.5-71.5S110.925,320,71.5,320z M71.5,448    C40.346,448,15,422.654,15,391.5S40.346,335,71.5,335s56.5,25.346,56.5,56.5S102.654,448,71.5,448z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.196,50.197l-26.696,26.697-10.696-10.697c-2.93-2.929-7.678-2.929-10.607,0s-2.929,7.678 0,10.606l16,16c1.464,1.465 3.384,2.197 5.303,2.197s3.839-0.732 5.304-2.197l32-32c2.929-2.929 2.929-7.678 0-10.606-2.93-2.929-7.678-2.929-10.608,7.10543e-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.196,210.197l-26.696,26.697-10.696-10.697c-2.93-2.929-7.678-2.929-10.607,0s-2.929,7.678 0,10.606l16,16c1.464,1.465 3.384,2.197 5.303,2.197s3.839-0.732 5.304-2.197l32-32c2.929-2.929 2.929-7.678 0-10.606-2.93-2.929-7.678-2.929-10.608,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.5,55h144c4.143,0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-144c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.5,103h280c4.143,0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-280c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.5,215h144c4.143,0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-144c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.5,248h-280c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5h280c4.143,0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.5,375h144c4.143,0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-144c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.5,408h-280c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5 7.5,7.5h280c4.143,0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSvgrepoCom);
export default __webpack_public_path__ + "static/media/task-svgrepo-com.2eda60648fcb43e5eb56f4db97e448ce.svg";
export { ForwardRef as ReactComponent };